import { Modal } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  onCreateCampaign: () => void
  onCancel: () => void
}

export const NoCampaignModal = ({ onCreateCampaign, onCancel }: Props) => {
  return (
    <Modal.Root size="sm" onPressOutside={onCancel}>
      <Modal.Header title="You need a campaign before creating content" />
      <Modal.Content>
        <Text>To create content, you need an active campaign. Set up your first campaign to get started.</Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" onPress={onCancel}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={onCreateCampaign}>Create Campaign</Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
